// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__30m2Y","title":"Header_title__3H5nT","left":"Header_left__2PMmm","clinicName":"Header_clinicName__1TTLh"};